import { loaders } from 'pixi.js';
import LoaderResource = loaders.Resource;
import Game from 'Game';

declare const __CDN_HASHES__: Record<string, string>;
const CDN_HASHES = __CDN_HASHES__;

export default function CDNMiddleware(resource: LoaderResource, next: any) {
    if (!(resource.url in CDN_HASHES)) return next();

    const fileName = resource.url.slice(resource.url.lastIndexOf('/') + 1);
    const extension = getFileExtension(fileName);
    const hash = CDN_HASHES[resource.url];
    const hashedFileName = extension ? fileName.replace(extension, `.${hash}${extension}`) : `${fileName}.${hash}`;

    const url = `${Game.sdk.getCDNUrl()}/${resource.url.replace(fileName, hashedFileName)}`;
    // save the original url
    // @ts-ignore
    resource.originalUrl = resource.url;
    // @ts-ignore Ignore pixi's readonly
    resource.url = url.replace(/([^:])(\/\/+)/g, '$1/');

    return next();
}

function getFileExtension(filename: string): string {
    // look for the device pixel ratio pattern (@Nx or @N.Nx)
    const pixelRatioMatch = filename.match(/@\d+(\.\d+)?x/);

    if (pixelRatioMatch) {
        // get the index where the pixel ratio pattern starts
        const matchStartIndex = pixelRatioMatch.index!;

        // everything from the @ symbol to the end of the file is considered the extension
        return filename.substring(matchStartIndex);
    }

    // for files without @ notation
    // try for double extensions (like .png.webm)
    const doubleExtMatch = filename.match(/(\.[^.]+\.[^.]+)$/);
    if (doubleExtMatch) {
        return doubleExtMatch[1];
    }

    // try for single extension
    const singleExtMatch = filename.match(/(\.[^.]+)$/);
    return singleExtMatch ? singleExtMatch[1] : '';
}